<!-- <div [brManageMenuButton]="menu"></div> -->
<mflooring-layout-wrapper
  [content]="layoutContainerProp.content"
  [presentation]="{ isInset: isInset }"
  id="layoutWrapper"
  class="{{handleSSRClass}}"
  >
  <div class="footer-container" [ngClass]="pageTitleVisDemo">
    @if (menu && menu.siteMenuItems.length) {
      @if (!isMobile) {
        <mflooring-footer-menu-desktop
          [menu]="menu"
          [page]="page"
          [footerData]="footerData"
        ></mflooring-footer-menu-desktop>
      }
      <!-- class="desktop" -->
      @if (isMobile) {
        <mflooring-footer-menu-mobile
          [menu]="menu"
          [page]="page"
          [footerData]="footerData"
        ></mflooring-footer-menu-mobile>
      }
      <!-- class="mobile" -->
    }
  </div>
</mflooring-layout-wrapper>

<mflooring-footer-copyright
  [content]="footerData"
  [ngClass]="pageTitleVisDemo"
  id="copyrightComp"
></mflooring-footer-copyright>
